import { useStepQuery, useCreateStepMutation, useUpdateStepMutation, useDeleteStepMutation } from './useStepsQuery';
import { Step } from '../types';

export const useStep = (stepId?: string) => {
    const { data: record, isLoading: loading, refetch: fetchRecord } = useStepQuery(stepId || '');
    const createStepMutation = useCreateStepMutation();
    const updateStepMutation = useUpdateStepMutation();
    const deleteStepMutation = useDeleteStepMutation();

    const createRecord = async (values: Step) => {
        return await createStepMutation.mutateAsync(values);
    };

    const updateRecord = async (values: Step) => {
        if (typeof stepId === 'undefined') {
            throw new Error('stepId is required parameter');
        }
        return await updateStepMutation.mutateAsync({ id: stepId, record: values });
    };

    const deleteRecord = async () => {
        if (typeof stepId === 'undefined') {
            throw new Error('stepId is required parameter');
        }
        return await deleteStepMutation.mutateAsync(stepId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
